import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { ApplicationSegment } from 'components/ApplicationSegment';
import { ProblematicStat } from 'modules/dashboard/hooks/useDashboardStats';
import { SegmentHeader } from './SegmentHeader';

const m = defineMessages({
  title: {
    id: 'Dashboard.View.TopProblematics.Title',
    defaultMessage: 'Top 3 préoccupations et problématiques',
  },
  entries: {
    id: 'Dashboard.View.TopProblematics.Entries',
    defaultMessage: 'Entrée(s)',
  },
  persons: {
    id: 'Dashboard.View.TopProblematics.Persons',
    defaultMessage: 'Personne(s)',
  },
  emptyMessage: {
    id: 'Dashboard.View.TopProblematics.EmptyMessage',
    defaultMessage: 'Aucune problématique/préoccupation',
  },
});

interface Props {
  topProblematics: ProblematicStat[];
}

export const TopProblematics: React.FC<Props> = ({ topProblematics }) => {
  const { formatMessage } = useIntl();

  const table = (
    <table className="tw-text-xs tw-w-full tw-max-w-lg">
      <thead>
        <tr>
          <th></th>
          <th></th>
          <th className="tw-text-right tw-p-1">{formatMessage(m.entries)}</th>
          <th className="tw-text-right tw-p-1">{formatMessage(m.persons)}</th>
        </tr>
      </thead>
      <tbody>
        {topProblematics.map((problematic, index) => (
          <tr className="tw-py-2" key={index}>
            <td className="tw-text-green tw-text-2xl tw-py-1 tw-pr-2">
              #{index + 1}
            </td>
            <td>{problematic.name}</td>
            <td className="tw-text-right tw-p-1">
              {problematic.entriesStat.entryCount}
            </td>
            <td className="tw-text-right tw-p-1">
              {problematic.entriesStat.personCount}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  const emptyMessage = <p>{formatMessage(m.emptyMessage)}</p>;

  return (
    <ApplicationSegment>
      <SegmentHeader header={formatMessage(m.title)} iconName="trophy" />
      {topProblematics.length ? table : emptyMessage}
    </ApplicationSegment>
  );
};
